<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>
    <div class="relative">
        <input v-if="!showPassword" type="password" :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input pr-10" :class="{ error: error }" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
        <font-awesome-icon v-if="!showPassword" class="cursor-pointer absolute bottom-3 right-3" icon="fa-eye" @click="toggleShow" />
        <input v-if="showPassword" type="text" :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input pr-10" :class="{ error: error }" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
        <font-awesome-icon v-if="showPassword" class="cursor-pointer absolute bottom-3 right-3" icon="fa-eye-slash" @click="toggleShow" />
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  data() {
    return {
      showPassword: false
    };
  },
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: String,
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    }
  },
}
</script>
